module.exports = __webpack_public_path__ + "5c94773eeaed17e6f5c897df372879b1.pdf";